import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { SERVER } from '../config/config';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Helper to check permissions
  // usage: can('projects.view') or can('projects.manage')
  const can = (permissionSlug) => {
    if (!user || !user.permissions) return false;
    // Super Admin bypass check (optional, but permissions usually include everything anyway)
    if (user.role === 'Super Admin') return true;
    return user.permissions.includes(permissionSlug);
  };

  // Helper to check role
  const hasRole = (roleName) => {
     return user?.role === roleName;
  };

  const fetchUser = async () => {
    try {
      const response = await axios.get(`${SERVER}/admin/me`, {
         withCredentials: true
      });
      if (response.status === 200) {
        setUser(response.data.admin);
      }
    } catch (error) {
      console.log('Not authenticated');
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${SERVER}/admin/login`, { email, password }, {
       withCredentials: true
    });
    setUser(response.data.admin);
    return response.data;
  };

  const logout = async () => {
     try {
       await axios.post(`${SERVER}/admin/logout`, {}, { withCredentials: true });
     } catch (err) {
       console.error(err);
     } finally {
       setUser(null);
       localStorage.removeItem('adminEmail');
     }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, can, hasRole, refreshUser: fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
